var React = require('react');

function Laptop (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#677581","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M5.768 6a1 1 0 0 1 1-1h10.5a1 1 0 0 1 1 1v8.5h-12.5V6z","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M8.5 7.5h1M12.5 7.5h3M9.5 9.5h4M14.5 11.5h1M10.5 11.5h2","key":1}),React.createElement("path",{"d":"m18.268 14.75.746 3.544a1 1 0 0 1-.979 1.206H6a1 1 0 0 1-.978-1.206l.746-3.544","strokeWidth":"1.5","key":2})]));
}

Laptop.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Laptop;

Laptop.default = Laptop;
